import Vue from 'vue'
import VueRouter from 'vue-router'
import Sys_Role from '../views/Sys_Role'
import Sys_Log_Info from '../views/Sys_Log_Info'
import Usage_Record_View from '../views/Usage_Record_View'
import Log_Info_View from '../views/Log_Info_View'
import Customer_Info from '../views/Customer_Info'
import Users from '../views/USERS'
import Para_Info from '../views/Para_Info'
import Area_Info from '../views/Area_Info'
import All_Device_Info from '../views/All_Device_Info'
import Acceptance_form from '../views/Acceptance_form'
import Account_Info from '../views/Account_Info'
import Event_over_list from '../views/Event_over_list'
import Site_Info from '../views/Site_Info'
import Login from '../views/Login'
import CameraFunc from '../views/CameraFunc'
import Usage_Month from '../views/Usage_Month'
import Realtime_Alert_View from '../views/Realtime_Alert_View'
import Model_Flow_Info from '../views/Model_Flow_Info'
import SignalR_test from '../views/SignalR_test'

import Language_info from '../views/Language_info'
import Dashboard from '../views/Dashboard'
import VideoTest from '../views/VideoTest'
import MdVideoPlayer from '../views/MdVideoPlayer'

import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/Sys_Role',
    name: 'Sys_Role',
    component: Sys_Role
  },
  {
    path: '/realtime_alert_view',
    name: 'Realtime_Alert_View',
    component: Realtime_Alert_View
  },
  {
    path: '/usage_Month',
    name: 'Usage_Month',
    component: Usage_Month
  },
  {
    path: '/event_over_list',
    name: 'Event_over_list',
    component: Event_over_list
  },
  {
    path: '/site_info',
    name: 'Site_Info',
    component: Site_Info
  },
  {
    path: '/account_info',
    name: 'Account_Info',
    component: Account_Info
  },
  {
    path: '/acceptance_form',
    name: 'Acceptance_form',
    component: Acceptance_form
  },
  {
    path: '/all_device_info',
    name: 'All_Device_Info',
    component: All_Device_Info
  },
  {
    path: '/para_info',
    name: 'Para_Info',
    component: Para_Info
  },
  {
    path: '/area_info',
    name: 'Area_Info',
    component: Area_Info
  },
  {
    path: '/sys_Log_Info',
    name: 'Sys_Log_Info',
    component: Sys_Log_Info
  },

  {
    path: '/usage_record_view',
    name: 'Usage_Record_View',
    component: Usage_Record_View
  },
  {
    path: '/log_info_view',
    name: 'Log_Info_View',
    component: Log_Info_View
  },
  {
    path: '/customer_info',
    name: 'Customer_Info',
    component: Customer_Info
  },
  {
    path: '/USERS',
    name: 'Users',
    component: Users
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login
  },
  {
    path: '/SignalR_test',
    name: 'SignalR_test',
    component: SignalR_test
  },
  {
    path: '/Dashboard',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/Language_info',
    name: 'Language_info',
    component: Language_info
  },
  {
    path: '/CameraFunc',
    name: 'CameraFunc',
    component: CameraFunc
  },
  {
    path: '/Model_Flow_Info',
    name: 'Model_Flow_Info',
    component: Model_Flow_Info
  },
  {
    path: '/VideoTest',
    name: 'VideoTest',
    component: VideoTest
  },
  {
    path: '/MdVideoPlayer',
    name: 'MdVideoPlayer',
    component: MdVideoPlayer
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  let basicUrl = ['/Login','/Dashboard', '/', '', '/CameraFunc', '/VideoTest', '/MdVideoPlayer'];
  if (basicUrl.indexOf(to.path) < 0) {
    if (store.state.permissions.indexOf(to.path) < 0) {
      //console.log(`[INDEX.JS] unauthed url: ${to.path}`)
      next('/Login')
      return
    }
  } 
  // console.log(`[INDEX.JS] authed url: ${from.path} -> ${to.path}`)
  next();
});

export default router
